<script setup lang="ts">
import { MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { useCollectionsStore } from '~/stores/collections-store';
import type { Collection } from '~/utilities/pyscript-api-models';
import DropdownMenu from '~/components/DropdownMenu.vue';
import IconMenu from '~icons/carbon/overflow-menu-vertical';
import IconTrashCan from '~icons/carbon/trash-can';
import IconPencil from '~icons/mdi/pencil-outline';

defineProps<{
  collection: Collection;
}>();

const collectionsStore = useCollectionsStore();
</script>

<template>
  <DropdownMenu>
    <template #button>
      <MenuButton
        class="rounded-full p-1 text-sm text-new-gray-800 outline-none transition-colors hover:bg-new-gray-100/50 dark:text-new-gray-100"
        aria-label="Menu"
      >
        <IconMenu aria-hidden="true" class="shrink-0 text-lg" />
      </MenuButton>
    </template>

    <template #menu>
      <MenuItems class="three-dot-menu__panel --right min-w-[8rem]">
        <MenuItem>
          <button
            class="three-dot-menu__item-btn"
            @click="collectionsStore.openCollectionModal(collection)"
          >
            <IconPencil aria-hidden="true" class="text-sm" />
            <span
              class="three-dot-menu__item-text"
              :data-content="$t('buttons.edit')"
              v-text="$t('buttons.edit')"
            />
          </button>
        </MenuItem>

        <MenuItem>
          <button
            class="three-dot-menu__item-btn hover:!bg-error-600 hover:text-white"
            @click="collectionsStore.deleteCollection(collection.id)"
          >
            <IconTrashCan aria-hidden="true" class="text-sm" />
            <span
              class="three-dot-menu__item-text"
              :data-content="$t('buttons.delete')"
              v-text="$t('buttons.delete')"
            />
          </button>
        </MenuItem>
      </MenuItems>
    </template>
  </DropdownMenu>
</template>

<style scoped lang="postcss"></style>
